export class Utils {

  public static convertArrayToObject(sourceData: Array<any>): any {

    if(sourceData) {
      let prototype = sourceData[0];

      let keys = Object.keys(prototype);

      let data = {};

      for (let key of keys) {
        data[key] = [];
      }

      for (let d of sourceData) {
        for (let key of keys) {
          data[key].push(parseFloat(d[key]));
        }
      }

      return data;
    } else {
      return {};
    }


    // return prototype;
  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/services/utils.ts